import { takeEvery, put } from 'redux-saga/effects';
import { actions as updateAttachmentsActions } from './get-user-attachment';
import { consts as deleteAttachmentConsts } from './delete-user-attachment';
import { consts as deleteOutcomeAttachmentConsts } from './delete-user-outcome-attachment';

function* updateDocumentsWorker(action) {
  const { payload } = action;
  const { uniqId } = payload;

  yield put(updateAttachmentsActions.deleteItem({ uniqId }));
}

export function* updateAttachmentsSaga() {
  yield takeEvery(
    [deleteAttachmentConsts.SEND, deleteOutcomeAttachmentConsts.SEND],
    updateDocumentsWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/profiles/updateAttachmentsSaga.js